import dev from "./config.dev"
import test from "./config.test"

export default process.env.REACT_APP_ENVIRONMENT === "dev" ? dev : test